import React, { useEffect, useState, useRef } from 'react';
import { Button, Icon } from '@common/components';
import cx from 'classnames';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useClickOutside } from '@common/hooks/useClickOutside';

import i18n, { fallbackLng } from '@common/config/i18n';
import languagePickerClasses from './LanguagePicker.module.scss';

export default function LanguagePicker() {
  const wrapperRef = useRef(null);

  const [clickOutside] = useClickOutside(wrapperRef);
  const OPTIONS = [
    { text: 'Es', i18value: 'es' },
    { text: 'En', i18value: 'en' },
    { text: 'Fr', i18value: 'fr' },
    { text: 'Pt', i18value: 'pt' },
    { text: 'Ct', i18value: 'ct' },
    { text: 'Eu', i18value: 'eu' },
  ];
  const [isOpen, setIsOpen] = useState(false);

  const getSelectedLanguage = (currentLang) =>
    OPTIONS.find((lang) => currentLang.indexOf(lang.i18value) > -1);

  const [selectedOption, setSelectedOption] = useState(
    getSelectedLanguage(i18n.language || fallbackLng),
  );

  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      setSelectedOption(getSelectedLanguage(lng));
    };

    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  const toggling = () => setIsOpen(!isOpen);

  const setLanguage = (lang) => {
    return i18n.changeLanguage(lang);
  };

  const onOptionClicked = (option) => () => {
    setSelectedOption(option);
    setIsOpen(false);
    setLanguage(option.i18value);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [clickOutside]);

  return (
    <div className={languagePickerClasses.dropdownContainer} ref={wrapperRef}>
      <Button
        className={cx([
          languagePickerClasses.dropdownHeader,
          languagePickerClasses.deletePadding,
        ])}
        onClick={toggling}
        color="font-primary"
        suffix={
          <Icon
            icon={faAngleDown}
            className={languagePickerClasses.iconWorld}
          />
        }
      >
        {selectedOption?.text || 'Eng'}
      </Button>
      {isOpen && (
        <div className={languagePickerClasses.dropdownListContainer}>
          <ul role="menu" className={languagePickerClasses.dropdownList}>
            {OPTIONS.map((option) => (
              <li
                className={languagePickerClasses.listItem}
                onClick={onOptionClicked(option)}
                key={Math.random()}
                aria-hidden="true"
              >
                <span>{option.text}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
